import { OUTBOUND_TYPE } from "@erp/shared/types/outbound-type.types";
import { STOCK_APPROVAL_PHASE } from "@erp/shared/types/stock-approval-phase.types";
import { PRODUCT_TYPE } from "@erp/shared/types/product.types";
export const mockOutboundSearchConfirm = [
    {
        id: 1,
        projectId: null,
        projectCode: "PRJ-2024-001",
        addData: OUTBOUND_TYPE.출고,
        approvalPhase: STOCK_APPROVAL_PHASE.승인,
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        createdTime: "2024-01-15T08:00:00Z",
        checker: 119,
        checkerId: "mbj",
        checkerName: "문병준",
        checkedDate: "2024-01-15T09:30:00Z",
        approver: 120,
        approverId: "ehj",
        approverName: "엄현준",
        approvedDate: "2024-01-15T14:20:00Z",
        rejecter: null,
        rejecterId: null,
        rejecterName: null,
        rejectedDate: null,
        rejectReason: null,
        outboundDate: "2024-01-16T10:00:00Z",
        outboundPlace: "A-창고",
        outboundSpotId: 1,
        outboundSpotName: "A-창고",
        purpose: "프로젝트 출고",
        note: "정상 출고 완료",
        inspectionReportFile: "inspection_report_001.pdf",
        etcFiles: ["receipt_001.pdf", "warranty_001.pdf"],
    },
    {
        id: 2,
        projectId: null,
        projectCode: "PRJ-2024-002",
        addData: OUTBOUND_TYPE.재고이동,
        approvalPhase: STOCK_APPROVAL_PHASE.미승인,
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        createdTime: "2024-01-17T09:00:00Z",
        checker: 119,
        checkerId: "mbj",
        checkerName: "문병준",
        checkedDate: null,
        approver: 119,
        approverId: "mbj",
        approverName: "문병준",
        approvedDate: null,
        rejecter: null,
        rejecterId: null,
        rejecterName: null,
        rejectedDate: null,
        rejectReason: null,
        outboundDate: "2024-01-17T11:30:00Z",
        outboundPlace: null,
        outboundSpotId: null,
        outboundSpotName: null,
        purpose: "재고 이동",
        note: "직접 입력된 재고",
        inspectionReportFile: null,
        etcFiles: null,
    },
    {
        id: 3,
        projectId: null,
        projectCode: "PRJ-2024-003",
        addData: OUTBOUND_TYPE.출고,
        approvalPhase: STOCK_APPROVAL_PHASE.반려,
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        createdTime: "2024-01-18T08:00:00Z",
        checker: 119,
        checkerId: "mbj",
        checkerName: "문병준",
        checkedDate: "2024-01-18T08:45:00Z",
        approver: 0,
        approverId: "",
        approverName: "",
        approvedDate: null,
        rejecter: 110,
        rejecterId: "user010",
        rejecterName: "임소영",
        rejectedDate: "2024-01-18T16:30:00Z",
        rejectReason: "자재 사양이 일치하지 않음",
        outboundDate: "2024-01-18T13:15:00Z",
        outboundPlace: "B-창고",
        outboundSpotId: 2,
        outboundSpotName: "B-창고",
        purpose: "현장 출고",
        note: "반려 처리됨",
        inspectionReportFile: "inspection_report_003.pdf",
        etcFiles: ["rejection_reason_003.pdf"],
    },
    {
        id: 4,
        projectId: null,
        projectCode: "PRJ-2024-004",
        addData: OUTBOUND_TYPE.재고이동,
        approvalPhase: STOCK_APPROVAL_PHASE.미확인,
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        createdTime: "2024-01-19T09:00:00Z",
        checker: 119,
        checkerId: "mbj",
        checkerName: "문병준",
        checkedDate: null,
        approver: 120,
        approverId: "ehj",
        approverName: "엄현준",
        approvedDate: null,
        rejecter: null,
        rejecterId: null,
        rejecterName: null,
        rejectedDate: null,
        rejectReason: null,
        outboundDate: "2024-01-19T14:45:00Z",
        outboundPlace: null,
        outboundSpotId: null,
        outboundSpotName: null,
        purpose: "재고 이동",
        note: "재고 이동 처리 중",
        inspectionReportFile: null,
        etcFiles: ["rework_plan_004.pdf"],
    },
    {
        id: 5,
        projectId: null,
        projectCode: "PRJ-2024-005",
        addData: OUTBOUND_TYPE.출고,
        approvalPhase: STOCK_APPROVAL_PHASE.미승인,
        creater: 116,
        createrId: "user016",
        createrName: "장미래",
        createdTime: "2024-01-20T08:30:00Z",
        checker: 117,
        checkerId: "user017",
        checkerName: "서동현",
        checkedDate: "2024-01-20T09:15:00Z",
        approver: 0,
        approverId: "",
        approverName: "",
        approvedDate: null,
        rejecter: null,
        rejecterId: null,
        rejecterName: null,
        rejectedDate: null,
        rejectReason: null,
        outboundDate: "2024-01-20T11:00:00Z",
        outboundPlace: "메인창고",
        outboundSpotId: 3,
        outboundSpotName: "메인창고",
        purpose: "현장 출고",
        note: "승인 대기 중",
        inspectionReportFile: null,
        etcFiles: ["approval_request_005.pdf"],
    },
];
export const mockOutboundProduct = [
    {
        id: 1,
        spotId: 101,
        type: PRODUCT_TYPE.원부자재,
        productId: 1001,
        classificationId: 3001,
        manufacturerId: 2001,
        classification: "전력기기-A",
        productCode: "PE-A-0001",
        name: "Capacitor",
        spot: "A-01-001",
        spec: "High Voltage Capacitor, 1000V 100uF",
        model: "HV-CAP-1000",
        manufacturer: "Samsung Electro-Mechanics",
        num: 5,
        unitPrice: 25000,
        addData: OUTBOUND_TYPE.출고,
        outboundConfirmId: 1,
        inboundId: null,
        outboundDate: "2024-01-15T08:00:00Z",
        outboundPlace: "메인창고",
        outboundSpotId: 3,
        outboundSpotName: "메인창고",
        purpose: "프로젝트 출고",
        createdTime: "2024-01-15T08:00:00Z",
        modifiedTime: "2024-01-15T08:00:00Z",
        modifier: 119,
        projectId: null,
        projectCode: "PRJ-2024-001",
        inspectionReportFile: "inspection_report_001.pdf",
        etcFiles: ["receipt_001.pdf"],
        note: "정상 출고 완료",
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        approvalPhase: STOCK_APPROVAL_PHASE.승인,
        checker: 119,
        checkedDate: "2024-01-15T09:30:00Z",
        checkerId: "mbj",
        checkerName: "문병준",
        approver: 120,
        approvedDate: "2024-01-15T14:20:00Z",
        approverId: "ehj",
        approverName: "엄현준",
        rejecter: null,
        rejectedDate: null,
        rejectReason: null,
        rejecterId: null,
        rejecterName: null,
        orderId: null,
        productTotalStockNum: 10,
    },
    {
        id: 2,
        spotId: 102,
        type: PRODUCT_TYPE.원부자재,
        productId: 1002,
        classificationId: 3002,
        manufacturerId: 2002,
        classification: "전력기기-B",
        productCode: "PE-B-0002",
        name: "Resistor",
        spot: "B-02-003",
        spec: "DC-Link Voltage Divider, PR100 1M 5%",
        model: "PR100-1M",
        manufacturer: "ATE",
        num: 10,
        unitPrice: 18500,
        addData: OUTBOUND_TYPE.출고,
        outboundConfirmId: 2,
        inboundId: null,
        outboundDate: "2024-01-15T08:00:00Z",
        outboundPlace: "메인창고",
        outboundSpotId: 3,
        outboundSpotName: "메인창고",
        purpose: "프로젝트 출고",
        createdTime: "2024-01-15T08:00:00Z",
        modifiedTime: "2024-01-15T08:00:00Z",
        modifier: 119,
        projectId: null,
        projectCode: "PRJ-2024-001",
        inspectionReportFile: "inspection_report_002.pdf",
        etcFiles: ["receipt_002.pdf"],
        note: "정상 출고 완료",
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        approvalPhase: STOCK_APPROVAL_PHASE.승인,
        checker: 119,
        checkedDate: "2024-01-15T09:30:00Z",
        checkerId: "mbj",
        checkerName: "문병준",
        approver: 120,
        approvedDate: "2024-01-15T14:20:00Z",
        approverId: "ehj",
        approverName: "엄현준",
        rejecter: null,
        rejectedDate: null,
        rejectReason: null,
        rejecterId: null,
        rejecterName: null,
        orderId: null,
        productTotalStockNum: 20,
    },
    {
        id: 3,
        spotId: 103,
        type: PRODUCT_TYPE.반제품,
        productId: 1003,
        classificationId: 3003,
        manufacturerId: 2003,
        classification: "제어기기-A",
        productCode: "SC-A-0003",
        name: "Microcontroller",
        spot: "C-01-005",
        spec: "ARM Cortex-M4, 32-bit, 168MHz",
        model: "STM32F407VGT6",
        manufacturer: "STMicroelectronics",
        num: 3,
        unitPrice: 45000,
        addData: OUTBOUND_TYPE.출고,
        outboundConfirmId: 3,
        inboundId: null,
        outboundDate: "2024-01-15T08:00:00Z",
        outboundPlace: "메인창고",
        outboundSpotId: 3,
        outboundSpotName: "메인창고",
        purpose: "프로젝트 출고",
        createdTime: "2024-01-15T08:00:00Z",
        modifiedTime: "2024-01-15T08:00:00Z",
        modifier: 119,
        projectId: null,
        projectCode: "PRJ-2024-001",
        inspectionReportFile: "inspection_report_003.pdf",
        etcFiles: ["receipt_003.pdf"],
        note: "정상 출고 완료",
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        approvalPhase: STOCK_APPROVAL_PHASE.승인,
        checker: 119,
        checkedDate: "2024-01-15T09:30:00Z",
        checkerId: "mbj",
        checkerName: "문병준",
        approver: 120,
        approvedDate: "2024-01-15T14:20:00Z",
        approverId: "ehj",
        approverName: "엄현준",
        rejecter: null,
        rejectedDate: null,
        rejectReason: null,
        rejecterId: null,
        rejecterName: null,
        orderId: null,
        productTotalStockNum: 5,
    },
    {
        id: 4,
        spotId: 104,
        type: PRODUCT_TYPE.완제품,
        productId: 1004,
        classificationId: 3004,
        manufacturerId: 2004,
        classification: "구조부품-A",
        productCode: "MP-A-0004",
        name: "Bearing",
        spot: "D-03-002",
        spec: "Deep Groove Ball Bearing, 6205-2RS",
        model: "6205-2RS",
        manufacturer: "NSK",
        num: 8,
        unitPrice: 12000,
        addData: OUTBOUND_TYPE.재고이동,
        outboundConfirmId: 4,
        inboundId: null,
        outboundDate: "2024-01-17T09:00:00Z",
        outboundPlace: "메인창고",
        purpose: "재고 이동",
        createdTime: "2024-01-17T09:00:00Z",
        modifiedTime: "2024-01-17T09:00:00Z",
        modifier: 119,
        projectId: null,
        projectCode: "PRJ-2024-002",
        inspectionReportFile: null,
        etcFiles: null,
        note: "재고 이동",
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        approvalPhase: STOCK_APPROVAL_PHASE.미승인,
        checker: 119,
        checkedDate: null,
        checkerId: "mbj",
        checkerName: "문병준",
        approver: 119,
        approvedDate: null,
        approverId: "mbj",
        approverName: "문병준",
        rejecter: null,
        rejectedDate: null,
        rejectReason: null,
        rejecterId: null,
        rejecterName: null,
        orderId: null,
        productTotalStockNum: 20,
    },
    {
        id: 5,
        spotId: 105,
        type: PRODUCT_TYPE.완제품,
        productId: 1005,
        classificationId: 3005,
        manufacturerId: 2005,
        classification: "통신기기-B",
        productCode: "EC-B-0005",
        name: "Connector",
        spot: "E-02-001",
        spec: "RJ45 Connector, 8P8C, Shielded",
        model: "RJ45-SH",
        manufacturer: "Amphenol",
        num: 15,
        unitPrice: 3500,
        addData: OUTBOUND_TYPE.출고,
        outboundConfirmId: 5,
        inboundId: null,
        outboundDate: "2024-01-18T08:00:00Z",
        outboundPlace: "메인창고",
        purpose: "프로젝트 출고",
        createdTime: "2024-01-18T08:00:00Z",
        modifiedTime: "2024-01-18T08:00:00Z",
        modifier: 119,
        projectId: null,
        projectCode: "PRJ-2024-003",
        inspectionReportFile: "inspection_report_005.pdf",
        etcFiles: ["rejection_reason_005.pdf"],
        note: "반려 처리됨",
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        approvalPhase: STOCK_APPROVAL_PHASE.반려,
        checker: 119,
        checkedDate: "2024-01-18T08:45:00Z",
        checkerId: "mbj",
        checkerName: "문병준",
        approver: 0,
        approvedDate: null,
        approverId: "",
        approverName: "",
        rejecter: 110,
        rejectedDate: "2024-01-18T16:30:00Z",
        rejectReason: "자재 사양이 일치하지 않음",
        rejecterId: "user010",
        rejecterName: "임소영",
        orderId: null,
        productTotalStockNum: 60,
    },
    {
        id: 6,
        spotId: 106,
        type: PRODUCT_TYPE.원부자재,
        productId: 1006,
        classificationId: 3006,
        manufacturerId: 2006,
        classification: "전력기기-C",
        productCode: "PE-C-0006",
        name: "Transformer",
        spot: "A-03-004",
        spec: "Power Transformer, 220V/24V, 100VA",
        model: "PT-220-24-100",
        manufacturer: "LG Innotek",
        num: 2,
        unitPrice: 85000,
        addData: OUTBOUND_TYPE.출고,
        outboundConfirmId: 6,
        inboundId: null,
        outboundDate: "2024-01-18T08:00:00Z",
        outboundPlace: "메인창고",
        purpose: "프로젝트 출고",
        createdTime: "2024-01-18T08:00:00Z",
        modifiedTime: "2024-01-18T08:00:00Z",
        modifier: 119,
        projectId: null,
        projectCode: "PRJ-2024-003",
        inspectionReportFile: "inspection_report_006.pdf",
        etcFiles: ["rejection_reason_006.pdf"],
        note: "반려 처리됨",
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        approvalPhase: STOCK_APPROVAL_PHASE.반려,
        checker: 119,
        checkedDate: "2024-01-18T08:45:00Z",
        checkerId: "mbj",
        checkerName: "문병준",
        approver: 0,
        approvedDate: null,
        approverId: "",
        approverName: "",
        rejecter: 110,
        rejectedDate: "2024-01-18T16:30:00Z",
        rejectReason: "자재 사양이 일치하지 않음",
        rejecterId: "user010",
        rejecterName: "임소영",
        orderId: null,
        productTotalStockNum: 5,
    },
    {
        id: 7,
        spotId: 107,
        type: PRODUCT_TYPE.반제품,
        productId: 1007,
        classificationId: 3007,
        manufacturerId: 2007,
        classification: "제어기기-B",
        productCode: "SC-B-0007",
        name: "Power MOSFET",
        spot: "C-02-001",
        spec: "N-Channel MOSFET, 100V, 30A",
        model: "IRF540N",
        manufacturer: "Infineon",
        num: 20,
        unitPrice: 2800,
        addData: OUTBOUND_TYPE.재고이동,
        outboundConfirmId: 7,
        inboundId: null,
        outboundDate: "2024-01-19T09:00:00Z",
        outboundPlace: "메인창고",
        purpose: "재고 이동",
        createdTime: "2024-01-19T09:00:00Z",
        modifiedTime: "2024-01-19T09:00:00Z",
        modifier: 119,
        projectId: null,
        projectCode: "PRJ-2024-004",
        inspectionReportFile: null,
        etcFiles: ["rework_plan_007.pdf"],
        note: "재고 이동 처리 중",
        creater: 119,
        createrId: "mbj",
        createrName: "문병준",
        approvalPhase: STOCK_APPROVAL_PHASE.미확인,
        checker: 119,
        checkedDate: null,
        checkerId: "mbj",
        checkerName: "문병준",
        approver: 120,
        approvedDate: null,
        approverId: "ehj",
        approverName: "엄현준",
        rejecter: null,
        rejectedDate: null,
        rejectReason: null,
        rejecterId: null,
        rejecterName: null,
        orderId: null,
        productTotalStockNum: 50,
    },
    {
        id: 8,
        spotId: 108,
        type: PRODUCT_TYPE.완제품,
        productId: 1008,
        classificationId: 3008,
        manufacturerId: 2008,
        classification: "구조부품-B",
        productCode: "MP-B-0008",
        name: "Screw",
        spot: "D-01-003",
        spec: "M6 x 20mm, Stainless Steel",
        model: "M6-20-SS",
        manufacturer: "Bossard",
        num: 100,
        unitPrice: 150,
        addData: OUTBOUND_TYPE.출고,
        outboundConfirmId: 8,
        inboundId: null,
        outboundDate: "2024-01-20T08:30:00Z",
        outboundPlace: "메인창고",
        purpose: "프로젝트 출고",
        createdTime: "2024-01-20T08:30:00Z",
        modifiedTime: "2024-01-20T08:30:00Z",
        modifier: 116,
        projectId: null,
        projectCode: "PRJ-2024-005",
        inspectionReportFile: null,
        etcFiles: ["approval_request_008.pdf"],
        note: "승인 대기 중",
        creater: 116,
        createrId: "user016",
        createrName: "장미래",
        approvalPhase: STOCK_APPROVAL_PHASE.미승인,
        checker: 117,
        checkedDate: "2024-01-20T09:15:00Z",
        checkerId: "user017",
        checkerName: "서동현",
        approver: 0,
        approvedDate: null,
        approverId: "",
        approverName: "",
        rejecter: null,
        rejectedDate: null,
        rejectReason: null,
        rejecterId: null,
        rejecterName: null,
        orderId: null,
        productTotalStockNum: 500,
    },
    {
        id: 9,
        spotId: 109,
        type: PRODUCT_TYPE.완제품,
        productId: 1009,
        classificationId: 3009,
        manufacturerId: 2009,
        classification: "통신기기-A",
        productCode: "EC-A-0009",
        name: "Cable",
        spot: "E-01-002",
        spec: "Ethernet Cable, Cat6, 305m",
        model: "CAT6-305",
        manufacturer: "LS Cable",
        num: 50,
        unitPrice: 1200,
        addData: OUTBOUND_TYPE.출고,
        outboundConfirmId: 9,
        inboundId: null,
        outboundDate: "2024-01-20T08:30:00Z",
        outboundPlace: "메인창고",
        purpose: "프로젝트 출고",
        createdTime: "2024-01-20T08:30:00Z",
        modifiedTime: "2024-01-20T08:30:00Z",
        modifier: 116,
        projectId: null,
        projectCode: "PRJ-2024-005",
        inspectionReportFile: null,
        etcFiles: ["approval_request_009.pdf"],
        note: "승인 대기 중",
        creater: 116,
        createrId: "user016",
        createrName: "장미래",
        approvalPhase: STOCK_APPROVAL_PHASE.미승인,
        checker: 117,
        checkedDate: "2024-01-20T09:15:00Z",
        checkerId: "user017",
        checkerName: "서동현",
        approver: 0,
        approvedDate: null,
        approverId: "",
        approverName: "",
        rejecter: null,
        rejectedDate: null,
        rejectReason: null,
        rejecterId: null,
        rejecterName: null,
        orderId: null,
        productTotalStockNum: 200,
    },
    {
        id: 10,
        spotId: 110,
        type: PRODUCT_TYPE.원부자재,
        productId: 1010,
        classificationId: 3010,
        manufacturerId: 2010,
        classification: "전력기기-D",
        productCode: "PE-D-0010",
        name: "Inductor",
        spot: "A-02-005",
        spec: "Power Inductor, 100uH, 5A",
        model: "PI-100-5A",
        manufacturer: "Coilcraft",
        num: 12,
        unitPrice: 8500,
        addData: OUTBOUND_TYPE.출고,
        outboundConfirmId: 10,
        inboundId: null,
        outboundDate: "2024-01-20T08:30:00Z",
        outboundPlace: "메인창고",
        purpose: "프로젝트 출고",
        createdTime: "2024-01-20T08:30:00Z",
        modifiedTime: "2024-01-20T08:30:00Z",
        modifier: 116,
        projectId: null,
        projectCode: "PRJ-2024-005",
        inspectionReportFile: null,
        etcFiles: ["approval_request_010.pdf"],
        note: "승인 대기 중",
        creater: 116,
        createrId: "user016",
        createrName: "장미래",
        approvalPhase: STOCK_APPROVAL_PHASE.미승인,
        checker: 117,
        checkedDate: "2024-01-20T09:15:00Z",
        checkerId: "user017",
        checkerName: "서동현",
        approver: 0,
        approvedDate: null,
        approverId: "",
        approverName: "",
        rejecter: null,
        rejectedDate: null,
        rejectReason: null,
        rejecterId: null,
        rejecterName: null,
        orderId: null,
        productTotalStockNum: 40,
    },
];
